import { useTheme } from '@mui/material';
const useHeaderStyles = () => {
    const theme = useTheme();
    return {
        headerContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            px: 5,
            height: 64,
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        logoContainerStyles: {
            // width: 48,
            // height: 48,
            img: {
                width: '100%',
                height: 'auto',
                objectFit: 'cover'
            }
        },
        NavInner: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        optionsContainerStyles: {
            display: 'flex',
            alignItems: 'center'
        },
        accessButtonStyles: {
            mr: '12px',
            height: 36
        },
        translationButtonStyles: {
            img: {
                width: 27.7,
                height: 20,
                objectFit: 'cover'
            }
        },
        notificationButtonStyles: {},
        profileAvatarStyles: {
            display: 'flex',
            padding: '2px',
            borderRadius: '50px',
            alignItems: 'flex-start',
            border: `2px solid ${theme.palette.action.hover}`
        },
        optionContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        profileInfoContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
            pl: 1
        },
        NavTitleContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center'
        },
        MobileHeaderContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: '8px 0px',
            minHeight: 48,
            alignItems: 'flex-start',
            width: '100%',
            gap: '6px',
            background: theme.palette.primary.main
        },
        markAsReadButtonStyles: {
            color: theme.palette.primary.contrastText
        }
    };
};
export default useHeaderStyles;
